import { inject, Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AppConfigService } from '../config/app-config.service';

@Injectable({ providedIn: 'root' })
export class AppInsightsService {
  private readonly appConfig = inject(AppConfigService);

  private client: ApplicationInsights | null = null;
  private initialized = false;

  initialize(): void {
    if (this.initialized) return;

    const key = this.appConfig.config()?.analytics?.instrumentationKey;
    if (!key) return;

    this.client = new ApplicationInsights({
      config: {
        instrumentationKey: key,
        enableAutoRouteTracking: true,
        disableExceptionTracking: false,
      }
    });

    this.client.loadAppInsights();
    this.client.trackPageView();
    this.initialized = true;
  }

  trackEvent(name: string, properties?: Record<string, string>): void {
    this.client?.trackEvent({ name }, properties);
  }

  trackException(error: Error): void {
    this.client?.trackException({ exception: error });
  }
}
